import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { IMAGES } from "@/constants/assets";

export default function Footer() {
  return (
    <footer className="border-t border-white/8 bg-black text-slate-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="relative w-12 h-12 rounded-sm bg-white/5 border border-white/10 p-2">
                <img src={IMAGES.logo} alt="Marco Polo Security" className="w-full h-full object-contain invert-logo" />
                <span className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-red-600 border-2 border-black" />
              </div>
              <div className="flex flex-col leading-tight">
                <span className="font-display font-black text-white text-lg uppercase">Marco Polo</span>
                <span className="font-condensed text-[10px] tracking-[0.22em] uppercase text-red-500 font-semibold">Security · WA</span>
              </div>
            </div>
            <p className="text-sm leading-relaxed max-w-md text-slate-400">
              Professional security officers, mobile patrol, and event security across Washington State.
              Trusted protection for businesses, homes, and construction sites.
            </p>
            <p className="mt-6 font-condensed text-xs font-bold tracking-[0.3em] uppercase text-red-500">
              Smart Scans, Stronger Security
            </p>
          </div>

          <div>
            <h4 className="font-condensed text-white font-bold uppercase tracking-[0.15em] text-sm mb-4">Quick Links</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">Services</Link></li>
              <li><Link to="/quote" className="hover:text-white transition-colors">Get Quote</Link></li>
              <li><Link to="/careers" className="hover:text-white transition-colors">Careers</Link></li>
              <li><Link to="/reviews" className="hover:text-white transition-colors">Reviews</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-condensed text-white font-bold uppercase tracking-[0.15em] text-sm mb-4">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2.5">
                <Phone className="w-4 h-4 mt-0.5 text-red-500 shrink-0" />
                <a href="tel:2067429195" className="hover:text-white">206-742-9195</a>
              </li>
              <li className="flex items-start gap-2.5">
                <Mail className="w-4 h-4 mt-0.5 text-red-500 shrink-0" />
                <a href="mailto:info@marcopolosecurity.com" className="hover:text-white">info@marcopolosecurity.com</a>
              </li>
              <li className="flex items-start gap-2.5">
                <MapPin className="w-4 h-4 mt-0.5 text-red-500 shrink-0" />
                <span>King & Pierce County<br />Washington State</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/8 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-slate-500 font-condensed uppercase tracking-widest">
          <span>© {new Date().getFullYear()} Marco Polo Security · All Rights Reserved</span>
          <div className="flex items-center gap-4">
            <Link to="/login" className="hover:text-white transition-colors" data-testid="footer-admin-link">Admin</Link>
            <span className="text-red-500">Licensed & Insured · Washington State</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
